import { atom, useSetAtom } from 'jotai'
import { draftSearchCriteria$ } from './draft'
import type { SearchCriteria } from './validate'

export function useToggleDraftIncludeClosedInventory() {
  return useSetAtom(toggleDraftIncludeClosedInventory$)
}

const toggleDraftIncludeClosedInventory$ = atom<null, [], SearchCriteria | undefined>(
  null,
  (get, set) => {
    set(draftSearchCriteria$, (current) => {
      const { includeClosedInventory, ...rest } = current ?? {}
      return includeClosedInventory ? rest : { ...rest, includeClosedInventory: true }
    })
    return get(draftSearchCriteria$)
  }
)
if (import.meta.vitest) {
  const { describe, test, expect } = import.meta.vitest
  const { createStore } = await import('jotai')
  describe('toggleDraftIncludeClosedInventory$', () => {
    test('undefined -> true', () => {
      const store = createStore()
      store.set(draftSearchCriteria$, {
        largeAreaCode: '07',
        mediumAreaCode: '002',
      } as SearchCriteria)
      const result = store.set(toggleDraftIncludeClosedInventory$)
      expect(result).toStrictEqual({
        largeAreaCode: '07',
        mediumAreaCode: '002',
        includeClosedInventory: true,
      })
    })
    test('true -> undefined', () => {
      const store = createStore()
      store.set(draftSearchCriteria$, {
        largeAreaCode: '07',
        mediumAreaCode: '002',
        includeClosedInventory: true,
      } as SearchCriteria)
      const result = store.set(toggleDraftIncludeClosedInventory$)
      expect(result).toStrictEqual({
        largeAreaCode: '07',
        mediumAreaCode: '002',
      })
    })
  })
}
